'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import PropTypes from 'prop-types';

import ButtonCTA from 'components/ui/ButtonCTA';
import ButtonCircle from 'components/ui/ButtonCircle';
import Img from 'components/ui/Img';

import { blockRootProps, getColor } from 'utils';

import styles from './BlockSubCategoryIntro.module.scss';

const BlockSubCategoryIntro = ({
    __typename,
    anchorId,
    backgroundColor,
    headline,
    description,
    cta,
    imageDesktop,
    imageMobile,
    backLink,
}) => {
    const desktopImage = imageDesktop;
    const mobileImage = imageMobile;

    if (!headline) {
        return null;
    }

    const backHref = backLink?.slug ? `/products/${backLink.slug}` : null;
    const hasImage = desktopImage?.url || mobileImage?.url;

    return (
        <div
            {...blockRootProps(anchorId, __typename)}
            className={styles.root}
            style={{
                '--hero-bg-color': backgroundColor
                    ? getColor(backgroundColor)
                    : undefined,
            }}
        >
            <div className={styles.textColumn}>
                {backHref && (
                    <a href={backHref} className={styles.backLink}>
                        <ButtonCircle
                            as="span"
                            aria-hidden="true"
                            theme="small-fill-white"
                            iconType="chevronRight"
                            className={styles.backLinkIcon}
                        >
                            <span />
                        </ButtonCircle>
                        {backLink.navLabel || backLink.title}
                    </a>
                )}
                <div className={styles.textBlock}>
                    <h1 className={styles.headline}>{headline}</h1>
                    {description && (
                        <p className={styles.description}>{description}</p>
                    )}
                    {cta?.text && (
                        <div className={styles.ctaGroup}>
                            <ButtonCTA {...cta} />
                        </div>
                    )}
                </div>
            </div>
            {hasImage && (
                <div className={styles.imageColumn}>
                    <Img
                        className={styles.heroImage}
                        src={desktopImage?.url || mobileImage?.url}
                        fallbackImageWidth={768}
                        priority
                        alt={
                            desktopImage?.description ||
                            mobileImage?.description ||
                            headline ||
                            ''
                        }
                        width={desktopImage?.width || mobileImage?.width}
                        height={desktopImage?.height || mobileImage?.height}
                        customSources={[
                            ...(desktopImage?.url
                                ? [
                                      {
                                          breakpoint: 1024,
                                          src: desktopImage.url,
                                          imageWidth: 1200,
                                      },
                                  ]
                                : []),
                            {
                                src: mobileImage?.url || desktopImage?.url,
                                imageWidth: 768,
                            },
                        ]}
                    />
                </div>
            )}
        </div>
    );
};

BlockSubCategoryIntro.propTypes = {
    __typename: PropTypes.string,
    anchorId: PropTypes.string,
    backgroundColor: PropTypes.string,
    headline: PropTypes.string,
    description: PropTypes.string,
    cta: PropTypes.object,
    imageDesktop: PropTypes.shape({
        description: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        url: PropTypes.string,
    }),
    imageMobile: PropTypes.shape({
        description: PropTypes.string,
        width: PropTypes.number,
        height: PropTypes.number,
        url: PropTypes.string,
    }),
    backLink: PropTypes.shape({
        slug: PropTypes.string,
        navLabel: PropTypes.string,
        title: PropTypes.string,
    }),
};

export default BlockSubCategoryIntro;
